import type { BillingInterval, StartCheckoutArgs } from './start-checkout';

/** The same intent travels through signup and the signed-in resume boundary. */
export function checkoutSignupUrl(args: StartCheckoutArgs): string {
  const params = new URLSearchParams({ plan: args.plan, interval: args.interval, checkout: '1' });
  if (args.promo) params.set('promo', args.promo);
  if (args.from) params.set('from', args.from);
  if (args.pack) params.set('pack', args.pack);
  return `/sign-up?redirect_url=${encodeURIComponent(`/pricing?${params}`)}`;
}

/** Claim once per mounted effect; signed-out renders must not consume intent. */
export function claimCheckoutResume(
  signedIn: boolean,
  params: Pick<URLSearchParams, 'get'>,
  fired: { current: boolean }
): StartCheckoutArgs | undefined {
  if (!signedIn || params.get('checkout') !== '1' || fired.current) return;
  const packParam = params.get('pack');
  const pack =
    packParam === '120' || packParam === '300' || packParam === '600' ? packParam : undefined;
  const plan = params.get('plan') ?? (pack ? `payg_${pack}` : null);
  if (!plan) return;
  fired.current = true;
  const interval: BillingInterval = params.get('interval') === 'monthly' ? 'monthly' : 'annual';
  return {
    plan,
    interval,
    page: '/pricing',
    from: params.get('from') ?? undefined,
    promo: params.get('promo') ?? undefined,
    ...(pack ? { pack } : {}),
  };
}

export function checkoutResumeFinishedUrl(params: URLSearchParams): string {
  const next = new URLSearchParams(params);
  next.delete('checkout');
  return `/pricing${next.toString() ? `?${next}` : ''}`;
}
